import script from "./TableActions.vue?vue&type=script&setup=true&lang=js"
export * from "./TableActions.vue?vue&type=script&setup=true&lang=js"

import "./TableActions.vue?vue&type=style&index=0&id=a0cd0ea8&scoped=true&lang=scss"
script.__scopeId = "data-v-a0cd0ea8"

export default script